import { ApiCurrentUser, UserPerm, SystemBasicInfo, SystemNetwork } from '../../types/api'

export interface State {
  basicInfo: SystemBasicInfo
  network: {
    setting: SystemNetwork
    status: SystemNetwork
  }
}

const thisState: State = {
  basicInfo: {
    name: '',
    description: '',
    location: '',
    contact: '',
    version: '',
    model: '',
    vendor: '',
    uptime: -1,
    date: -1,
    serialNumber: '',
    cpu: -1,
    diskTotal: 1,
    diskUsage: 1,
    ramTotal: 1,
    ramUsage: 1,
  },
  network: {
    setting: {
      dhcpClient: false,
      mac: '',
      ip: '',
      ipv6: '',
      netmask: '',
      gateway: '',
      dns: '',
    },
    status: {
      dhcpClient: false,
      mac: '',
      ip: '',
      ipv6: '',
      netmask: '',
      gateway: '',
      dns: '',
    }
  }
}

const mutations = {
  assignBasicInfo (state: State, nv: SystemBasicInfo) { state.basicInfo = nv },
  assignNetworkSetting (state: State, nv: SystemNetwork) { state.network.setting = nv },
  assignNetworkStatus (state: State, nv: SystemNetwork) { state.network.status = nv },
}

const actions = {
}

export default {
  namespaced: true,
  state: thisState,
  mutations,
  actions
}
